import { Link, useRouterState } from '@tanstack/react-router'

import { NAV_GROUPS } from '@/components/nav-items'
import { isActive } from '@/lib/nav'
import { cn } from '@/lib/utils'

export function SidebarNav({
  onNavigate,
  label = 'Main',
}: {
  onNavigate?: () => void
  label?: string
}) {
  const pathname = useRouterState({ select: (state) => state.location.pathname })

  return (
    <nav aria-label={label} className="flex flex-col gap-4 px-3.5 pt-1 pb-5">
      {NAV_GROUPS.map((group) => (
        <div key={group.label} className="flex flex-col gap-0.5">
          <h6 className="px-2 pt-1.5 pb-1 text-neutral-600">{group.label}</h6>
          {group.items.map((item) => {
            const active = isActive(pathname, item.to)
            return (
              <Link
                key={item.to}
                to={item.to}
                // The router marks any prefix match as current; `/` would be current everywhere.
                activeOptions={{ exact: item.to === '/' }}
                onClick={onNavigate}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex items-center gap-2.5 px-2 py-1.5 text-sm transition-colors',
                  active
                    ? 'bg-steel-100 text-steel-700 shadow-[inset_2px_0_0_var(--steel)]'
                    : 'hover:bg-foreground/5 text-foreground',
                )}
              >
                <item.icon className="size-4 shrink-0 opacity-70" strokeWidth={1.5} />
                <span className="truncate">{item.label}</span>
              </Link>
            )
          })}
        </div>
      ))}
    </nav>
  )
}
